import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { QuickAddBase } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/QuickAdd/QuickAddBase";
import { QuickAddTrackingEventsContextProvider } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/QuickAdd/QuickAddTrackingEventsContext/QuickAddTrackingEventsContextProvider";
import { DeferRenderedQuickAdd } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/QuickAdd/Search/DeferRenderedQuickAdd";
import { MaybePersistQuickAddOnSearch } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/QuickAdd/Search/MaybePersistQuickAddOnSearch";
import { ComponentDisplayOnHoverContainer } from "../../ComponentDisplayOnHoverContainer";
export var QuickAdd = function(param) {
    var data = param.data, showOnHover = param.showOnHover;
    var _data_productToken;
    return /*#__PURE__*/ _jsx(MaybePersistQuickAddOnSearch, {
        showOnHover: showOnHover,
        hoverQuickAdd: /*#__PURE__*/ _jsx(ComponentDisplayOnHoverContainer, {
            children: /*#__PURE__*/ _jsx(QuickAddTrackingEventsContextProvider, {
                data: data,
                children: /*#__PURE__*/ _jsx(QuickAddBase, {
                    data: data
                })
            })
        }, (_data_productToken = data.productToken) !== null && _data_productToken !== void 0 ? _data_productToken : ""),
        nonHoverQuickAdd: /*#__PURE__*/ _jsx(DeferRenderedQuickAdd, {
            data: data
        })
    });
};
